import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";

export const BusinessSettingsSidebarHeaderSkeleton = () => (
  <Stack align="start" gap={1} className="w-full shrink-0 px-6 pt-5 pb-4">
    <Skeleton className="h-3 w-12" />
    <Skeleton className="h-5 w-32" />
  </Stack>
);
